export const SCANNER_MARKETS = { both: 'Stocks + crypto', stock: 'US stocks', crypto: 'Crypto only' };

export const assertScannerRun = (run, expectedId, expectedMarket) => {
  if (!run || typeof run.id !== 'string' || !run.id.trim() || !SCANNER_MARKETS[run.market]
      || (expectedId && run.id !== expectedId) || (expectedMarket && run.market !== expectedMarket)) {
    throw new Error('Scan identity or market changed unexpectedly. No replacement scan was started.');
  }
};